import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {AccountingAccountModel} from '../accountingAccount.model';
import {ValueAndLabelConverter} from '../../../../../common/converter/ValueAndLabel.converter';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AccountingAccountConverter extends HttpModelConverter<AccountingAccountModel> {

    protected createInstance(): AccountingAccountModel {
        return new AccountingAccountModel();
    }

    protected enrichObject(result: AccountingAccountModel, src: AccountingAccountModel) {
        result.type = new ValueAndLabelConverter().convert(src.type);
    }
}
